module.exports = __webpack_public_path__ + "media/images/home-banners/sky-1117008_1280-a1fdd1e3977a17bc30d97947b38a02a3.jpg";